export enum WorkflowStatus {
	DrugTestInitiated = 101,
	PendingResults = 102,
    DrugTestComplete = 103,
	Deleted = 104,
	PendingInitialEntry = 301,
	TeamReview = 302,
	Eligible = 303,
	NotEligible = 304,
	OptedOut = 305,
	InProgress = 401,
	MovedToPhaseOne = 402,
	MovedToPhaseTwo = 403,
	MovedToPhaseThree = 404,
	MovedToPhaseFour = 405,
	MovedToPhaseFive = 406,
	CaseClosed = 407,
	CaseComplete = 408,
	InCustody = 409,
	InResidential = 410,
	Suspension = 411,
	ClosureInProgress = 501,
	ClosureComplete = 502,
	ClosureCanceled = 503,
}